export default __webpack_public_path__ + "static/media/cap.807f6c1b.mp4";